import { useCallback } from 'react';
import GoogleAnalytics from '../../../vendor/GoogleAnalytics';
const useColumn = () => {
    const onClickHtmlLabel = useCallback((e) => {
        GoogleAnalytics.sendClickEvent('column', `column_${e.currentTarget.dataset.label}`);
    }, []);
    const onClickRegistration = useCallback(() => {
        GoogleAnalytics.sendClickEvent('column', 'column_registration_click');
    }, []);
    return {
        onClickHtmlLabel,
        onClickRegistration,
    };
};
const useProffitSearch = () => {
    const onClickLandingPageModalLink = useCallback(() => {
        GoogleAnalytics.sendClickEvent('proffit_search', 'proffitsearch_btnclick');
    }, []);
    const onClickRegistration = useCallback(() => {
        GoogleAnalytics.sendClickEvent('proffit_search', 'proffitsearch_registrationclick');
    }, []);
    return {
        onClickLandingPageModalLink,
        onClickRegistration,
    };
};
export default {
    useColumn,
    useProffitSearch,
};
